import type { DATA_TESTID_ATTRIBUTE } from '@app/constants';
import type { NAccessRights } from '@app/types/AccessRights';

export namespace NNavigation {
  export type Main = Array<NavigationItem>;

  export type NavigationItem = SidebarItem | NotSidebarItem;

  export type NavigationAllItems = SidebarItem & NotSidebarItem;

  export type SidebarParentId = string;

  export type GeneralItemProps = {
    id: string;
    label: string | JSX.Element;
    path: string;
    element?: JSX.Element;
    className?: string;

    // Свойства ниже нужно оставить без camelCase,
    // иначе Реакт ругается при рендере навигации
    sidebarparentid: SidebarParentId;
    pagebreadcrumbdatatestid?: string;
    pagetitledatatestid?: string;
  };

  export type SidebarItem = GeneralItemProps & {
    title?: string;
    key: string;
    icon: JSX.Element;
    [DATA_TESTID_ATTRIBUTE]?: string;
    issidebaritem?: boolean | string;
    moduleKey?: number;
    relativepath?: string;
    children?: Array<NavigationItem>;

    // Свойства ниже нужно оставить без camelCase,
    // иначе Реакт ругается при рендере навигации
    servicerightsid?: NAccessRights.EntityId;
  };

  export type NotSidebarItem = GeneralItemProps & {
    // Свойства ниже нужно оставить без camelCase,
    // иначе Реакт ругается при рендере навигации
    issidebaritem?: boolean | string;
    servicerightsid?: NAccessRights.EntityId;
  };

  export type Settings = Array<PagesGroupInSettings>;

  export type PagesGroupInSettings = {
    groupDataTestId: string;
    groupName: EGroupNameInSettings;
    items: Array<PageInSettings>;
  };

  export enum EGroupNameInSettings {
    RECORD_SETTINGS = 'Настройки записи',
    SYSTEM_SETTINGS = 'Системные настройки',
    BRANCHES_AND_CHAINS = 'Филиалы и сети',
    PERSONAL_SETTINGS = 'Личные настройки',
    AI_OPERATOR = 'ИИ-агент',
    FINANCES = 'Финансы',
    WAREHOUSE = 'Склад',
    LEADS_AND_CLIENTS = 'Клиенты и лиды',
  }

  export interface PageInSettings {
    name: string;
    path: string;
    dataTestId?: string;
  }
}
